/**
 * BreadcrumbItem.jsx
 *
 * @Author: zhangce
 * @Date: 18/1/23 下午2:44
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../button';

/**
 * BreadcrumbItem
 * */
class BreadcrumbItem extends React.PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 类名
     * */
    className: PropTypes.string,
    /**
     * 分隔符
     * */
    separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
     * 跳转链接
     * */
    href: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'ne-breadcrumb-item',
  };

  render() {
    const { prefixCls, className, separator, children, ...other } = this.props;
    const classes = classNames(prefixCls, className);
    return (
      <span className={classes}>
        <Button variant="text" className={`${prefixCls}-button`} {...other}>
          {children}
        </Button>
        <span className={`${prefixCls}-separator`}>{separator}</span>
      </span>
    );
  }
}

export default BreadcrumbItem;



// WEBPACK FOOTER //
// ./src/breadcrumb/BreadcrumbItem.jsx